import React from 'react'
import sortBy from 'lodash.sortby'
import groupBy from 'lodash.groupby'

import Heading from '../../atoms/Typography/Heading'
import List from './List'
import ListItem from '../../atoms/ListItem'
import Link from '../../atoms/Link'
import Container from '../../atoms/Container'
import Col from '../../atoms/Col'

import Blank from '../Blank'

import Section from './Section'
import Market from './Market'
import State from './State'

import { byAlpha } from '../../helpers'

export default ({ markets: m, displayMarketsByState, header, ...props }) => {
  const markets = sortBy(m.items, ['state.name', 'market.title']).filter(
    m => !m.marketingCoop && !m.submarket && m.apartments.items.length > 0,
  )
  const states = groupBy(markets, 'state.name')

  return (
    <Blank {...props}>
      {header}
      <Container>
        <Section>
          <Heading as='h4'>Explore</Heading>
          <Col>
            <Heading as='h2'>Locations</Heading>
          </Col>
          <Col>
            <List columns={displayMarketsByState}>
              {displayMarketsByState
                ? Object.keys(states)
                    .sort(byAlpha)
                    .map(state => (
                      <State key={state} variant={displayMarketsByState ? 'underline' : ''}>
                        {state}
                        <List>
                          {states[state].map((market, m) => (
                            <Market key={m}>
                              <Link href={market.marketPage && market.marketPage.slug}>
                                {market.title}
                              </Link>
                            </Market>
                          ))}
                        </List>
                      </State>
                    ))
                : markets.map((market, m) => (
                    <Market key={m}>
                      <Link href={market.marketPage && market.marketPage.slug}>{market.title}</Link>
                    </Market>
                  ))}
            </List>
          </Col>
        </Section>
        {markets.map((market, m) => (
          <Section key={m}>
            {m === 0 || market.state.name !== markets[m - 1].state.name ? (
              <Heading as='h4'>{market.state.name}</Heading>
            ) : null}
            <Col>
              <Heading as='h2'>
                <Link href={market.marketPage && market.marketPage.slug}>{market.title}</Link>
              </Heading>
            </Col>
            <Col>
              <List>
                {market.apartments.items.map((apartment, a) => (
                  <ListItem key={a}>
                    <Link
                      trackingData={{
                        event: 'Open Apartment Website',
                        apartment: apartment.name,
                      }}
                      href={apartment.marketingWebsiteUrl}
                      target='_blank'
                    >
                      {apartment.name}
                    </Link>
                  </ListItem>
                ))}
              </List>
            </Col>
          </Section>
        ))}
      </Container>
    </Blank>
  )
}
